export default __webpack_public_path__ + "img/right5.eecceed5.jpg";